/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Component, Fragment } from "react";
import NavBar from "../components/global/NavBar";
import {Grid, CircularProgress, Typography, Button, Paper, Drawer} from "@material-ui/core";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Redirect } from "react-router-dom";
import {
    getSomeClassifications,
    getSomeLocalExplanation,
    getSomeExplanations,
    getDataset,
    getConfig,
    getListOfAlgorithms,
    getInformationGraphComparation, buildFingramsTest, getTest, uploadTest
} from "../components/global/API";
import CustomizedSnackbars from "../components/global/CustomizedSnackbars";
import AlgorithmCard from "../components/algorithm/AlgorithmCard";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";
import galicia from "../components/images/galicia.png";
import usc from "../components/images/usc.png";
import campusVida from "../components/images/campusvida.png";
import ue from "../components/images/ue.png";
import xunta from "../components/images/xunta.png";
import IconButton from "@material-ui/core/IconButton";
import ScatterChart from "recharts/lib/chart/ScatterChart";
import CartesianGrid from "recharts/lib/cartesian/CartesianGrid";
import XAxis from "recharts/lib/cartesian/XAxis";
import YAxis from "recharts/lib/cartesian/YAxis";
import Scatter from "recharts/lib/cartesian/Scatter";
import Tooltip from "recharts/lib/component/Tooltip";
import LabelList from "recharts/lib/component/LabelList";
import Legend from "recharts/lib/component/Legend";
import xacobeo from "../components/images/xacobeo-color-original.jpg";
import citius_horizontal from "../components/images/citius_horizontal.png";
import ResponsiveContainer from "recharts/lib/component/ResponsiveContainer";
import ExplanationPanelGraph from "../components/classifiers/ExplanationPanelGraph";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import LockOpenIcon from "@material-ui/icons/LockOpenTwoTone";
import LockIcon from "@material-ui/icons/LockTwoTone";
import Select from "react-virtualized-select";
import {CloudUpload} from "@material-ui/icons";
import FormLabel from "@material-ui/core/FormLabel";


const styles = theme => ({
    root: {
        marginTop: 40,
        justifyContent: "center",
        justifyItems: "center",
        display: "-webkit-flex",
        webkitFlexWrap: "wrap",
        flexWrap: "wrap",

    },
    select: {
        width: "100%",
        padding: 10,
        fontFamily: "Roboto"
    },
    selectDiv: {
        width: "90%",
        padding: 10
    },
    selected: {
        borderBottom: "solid",
        borderBottomColor: "#4caf50",
        width: "90%",
        padding: 10
    },
    paperRight: {
        padding: 10,
        margin: 5,
        height: "100%",
        minHeight: "500px",
        display: "flex",
        flexDirection: "column",
        marginBottom:50,
    },
    container: {
        marginTop: 30,
        justifyContent: "center",
        justifyItems: "center",
        display: "grid",
        webkitFlexWrap: "wrap",
        flexWrap: "wrap",
        textAlign:"center",
    },
    containerResponsive: {
        marginTop: 30,
        textAlign:"center",
    },
    button: {
        marginTop: "30px",
        width:"150px",
        backgroundColor: "#4caf50",
        fontSize: "20px",
        color: "white",
        "&:hover": {
            backgroundColor: "#357a38"
        }
    },
    buttonCancel: {
        width:"150px",
        marginTop: "30px",
        backgroundColor: "#ff5f52",
        fontSize: "20px",
        color: "white",
        "&:hover": {
            backgroundColor: "#C62828"
        }
    },
    progress: {
        margin: "auto",
        marginTop: 40,
        marginBottom: 30
    },
    footer:{
        boxShadow: "0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
        display:"inline-table",
        justifyContent:"space-evenly",
        position:"fixed",
        bottom:0,
        height:100,
        left:0,
        width:"100%",
        backgroundColor:"white",
    },
    centerFotter:{
        display:"flex",
        justifyContent:"space-evenly",
    },
    leftLogos: {
        height: 36,
        marginTop: 20,
        marginBottom: 20
    },
    rightLogos: {
        height: 60,
        marginTop: 20,
        marginBottom: 20
    },
    loader: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        justifyItems: "center"
    },
    switchClassDisabled:{
        color:"primary",
    },
    table: {
        minWidth: 650,
        td:{
            border:"solid #e0e0e0",
        }
    },
    tableAttCell: {
        border:"solid #e0e0e0",
    },
    head: {
        backgroundColor: "#4caf50",
        fontcolor: "white",
    },
});

class AlgorithmsComparationGraph extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: this.props.classifierExists ? this.props.dataset : "example",
            nameError: false,
            error: false,
            loading: true,
            file: undefined,
            j48: true,
            randomTree: true,
            repTree: true,
            furia: true,
            htFuzzy: true,
            randomForest: true,
            j48Configuration: false,
            randomTreeConfiguration: false,
            repTreeConfiguration: false,
            furiaConfiguration: false,
            htFuzzyConfiguration: false,
            randomForestConfiguration: false,
            checkedA: true,
            checkedB: false,
            checkedSeparated:false,
            FURIAparams: {
                tnorm: 0,
                batchSize: 100,
                checkErrorRate: true,
                doNotCheckCapabilities: false,
                folds: 3,
                minNo: 2,
                numDecimalPlaces: 2,
                optimizations: 2,
                seed: 1,
                uncovAction: 0
            },
            HTparams: {
                fuzzyCardinality: true,
                fuzzySets: 3,
                propertyLabels: "L1,L2,L3",
                centroids: "0.5",
                gracePeriod: 25.0,
                hoeffdingTieThreshold: 2.5,
                leafPredictionStrategy: 0,
                minimumFractionOfWeightInfoGain: 0.01,
                naiveBayesPredictionThreshold: 0.0,
                numDecimalPlaces: 2,
                printLeafModels: false,
                admitRepetitions: false,
                splitConfidence: 1.0e-7,
                splitCriterion: 1
            },
            J48params: {
                binarySplits: false,
                collapseTree: true,
                doNotMakeSplit: false,
                confidenceFactor: 0.25,
                minNumObj: 2,
                numFolds: 3,
                reduceError: false,
                seed: 1,
                subtreeRaising: true,
                unpruned: false,
                useLaplace: false,
                useMDL: true
            },
            Randomparams: {
                valueK: 0,
                minNumObj: 1,
                minVarianceProp: 0.001,
                seed: 1,
                maxDepth: 0,
                numFolds: 0,
                allowUnclassified: false,
                breakTies: false,
                numDecimalPlaces: 2
            },
            REPparams: {
                noCheckCapabilities: false,
                initialCount: 0,
                maxDepth: -1,
                minNumObj: 2,
                minVarianceProp: 0.001,
                noPruning: false,
                numDecimal: 2,
                numFolds: 3,
                seed: 1,
                spreadInitialCount: false
            },
            RandomForestParams: {
                bagSizePercent: 100,
                batchSize: 100,
                breakTiesRandomly: false,
                calcOutOfBag: false,
                completeAttributeImportance: false,
                debug: false,
                doNotCheckCapabilities: false,
                maxDepth: 0,
                numDecimalPlaces: 2,
                numExecutionSlots: 1,
                numFeatures: 0,
                numIterations: 100,
                outputOutOfBagComplexityStatistics: false,
                printClassifiers: false,
                seed: 1,
                storeOutOfBagPredictions: false,
            },
            clickButton: false,
            checkedConcepts: true,
            checkedRules: true,
            checkedTRL:true,
            compareTable:false,
            showGraph:false,
            checkedLocal:true,
            checkedGlobal:true,
            graphComparative:[],
            graphComparativeHidden:[],
            graphComparativeHiddenSaved:[],
            graphComparativeHiddenNr:[],
            graphComparativeSavedNr:[],
            graphComparativeHiddenNc:[],
            graphComparativeSavedNc:[],
            graphComparativeHiddenTrl:[],
            graphComparativeSavedTrl:[],
            value:0,
            typeInstanceSelected:0,
        };
        this.changeFile = this.changeFile.bind(this);
        this.handleAlgorithmClick = this.handleAlgorithmClick.bind(this);
        this.selectOneAlgorithm = this.selectOneAlgorithm.bind(this);
        this.changeAlgorithm = this.changeAlgorithm.bind(this);
        this.cancelBuild = this.cancelBuild.bind(this);
        this.handleChangeSwitchA = this.handleChangeSwitchA.bind(this);
        this.handleChangeSwitchB = this.handleChangeSwitchB.bind(this);
        this.handleChangeSwitchSeparated = this.handleChangeSwitchSeparated.bind(this);
        this.handleChangeRules = this.handleChangeRules.bind(this);
        this.handleChangeConcepts = this.handleChangeConcepts.bind(this);
        this.getConfig = this.getConfig.bind(this);
        this.getLocalExplanations = this.getLocalExplanations.bind(this);
        this.getSomeGlobalExplanation = this.getSomeGlobalExplanation.bind(this);
        this.getDataset = this.getDataset.bind(this);
        this.goBackSelectAlgorithms = this.goBackSelectAlgorithms.bind(this);
        this.goBackGeneralInformation = this.goBackGeneralInformation.bind(this);
        this.buildClassifier = this.buildClassifier.bind(this);
        this.returnToAlgorithms = this.returnToAlgorithms.bind(this);
        this.selectLine = this.selectLine.bind(this);
        this.selectLineAll = this.selectLineAll.bind(this);
        this.handleChangeTRL = this.handleChangeTRL.bind(this);
        this.handleChangeTest = this.handleChangeTest.bind(this)
        this.handleChangeTrain = this.handleChangeTrain.bind(this);
        this.changeLock = this.changeLock.bind(this);
        this.uploadTest = this.uploadTest.bind(this);
        this.classify = this.classify.bind(this);
        this.handleChangeGlobal = this.handleChangeGlobal.bind(this);
        this.handleChangeLocal = this.handleChangeLocal.bind(this);
    }

    componentDidMount() {
        Promise.all([
            this.getListOfAlgorithms(),
        ]).then(() => {
            this.setState({
                loading: false
            });
        });
    }

    async getListOfAlgorithms() {
        var response = await getListOfAlgorithms(
            this.props.dataset,
            this.props.token
        );

        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    redirect: true
                });
            } else {
                this.setState({
                    error: true,
                    message: response.data
                });
            }
        } else {
            console.log(response)
            this.setState(
                {
                    listOfAlgorithms:response.data,
                }
            );
        }
    }
    async goBackSelectAlgorithms() {
        this.setState({compareTable: false});
    }
    async goBackGeneralInformation(){
        this.setState({goBackGeneralInformation: true});
    }
    async buildClassifier(){
        var numberGraphs=0;
        if(this.state.checkedRules){
            numberGraphs++;
        }
        if(this.state.checkedConcepts){
            numberGraphs++;
        }
        if(this.state.checkedTRL){
            numberGraphs++;
        }
        if((!this.state.checkedRules && !this.state.checkedTRL && !this.state.checkedConcepts && !this.state.checkedLocal && !this.state.checkedGlobal)){
            this.props.handleGlobalMessage("error",this.props.language.labels[this.props.language.id].errorMessageLeastAlgorithmGraph)
        }else if((!this.state.j48 && !this.state.randomTree && !this.state.repTree && !this.state.furia && !this.state.furia && !this.state.htFuzzy && !this.state.randomForest)){
            this.props.handleGlobalMessage("error",this.props.language.labels[this.props.language.id].errorMessageLeastExplanationGraph)
        } else if((!this.state.j48 && !this.state.randomTree && !this.state.repTree && !this.state.furia && !this.state.furia && !this.state.htFuzzy && this.state.randomForest && !this.state.checkedLocal && !this.state.checkedGlobal )){
            this.props.handleGlobalMessage("error",this.props.language.labels[this.props.language.id].errorIEERandomForest)
        }else {
            var response = await getInformationGraphComparation(
                this.props.dataset,
                this.state.j48,
                this.state.randomTree,
                this.state.repTree,
                this.state.furia,
                this.state.htFuzzy,
                this.state.randomForest,
                this.props.token
            )
            if (response.error) {
                if (response.status === 401) {
                    this.props.handleGlobalMessage(
                        "error",
                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                    );
                    this.props.closeSession();
                    this.setState({
                        loading: false,
                        redirect: true
                    });
                } else {
                    //await deleteDataset(this.state.name, this.props.token);
                    this.setState({
                            loading: false,
                            error: true,
                            message: response.data
                        },
                    );
                }
            } else {
                //Crear unha copia na que se poida almacenar a respuesta e des
                const graphComparativeSaved = JSON.parse(JSON.stringify(response.data));
                var graphComparativeTogetherNr = JSON.parse(JSON.stringify(response.data));
                var graphComparativeTogetherNc = JSON.parse(JSON.stringify(response.data));
                var graphComparativeTogetherTrl = JSON.parse(JSON.stringify(response.data));
                graphComparativeTogetherNr.map(x => {
                    x.algorithm = x.algorithm + "-NR";
                })
                graphComparativeTogetherNc.map(x => {
                    x.algorithm = x.algorithm + "-NC";
                    x.numberOfRules = x.numberOfConcepts;
                })
                graphComparativeTogetherTrl.map(x => {
                    x.algorithm = x.algorithm + "-TRL";
                    x.numberOfRules = x.trl;
                })
                const graphComparativeSavedNr = JSON.parse(JSON.stringify(graphComparativeTogetherNr));
                const graphComparativeSavedNc = JSON.parse(JSON.stringify(graphComparativeTogetherNc));
                const graphComparativeSavedTrl = JSON.parse(JSON.stringify(graphComparativeTogetherTrl));
                this.setState({
                    graphComparative: response.data,
                    graphComparativeSaved: graphComparativeSaved,
                    graphComparativeTogetherTrl: graphComparativeTogetherTrl,
                    graphComparativeTogetherNr: graphComparativeTogetherNr,
                    graphComparativeTogetherNc: graphComparativeTogetherNc,
                    graphComparativeSavedTrl: graphComparativeSavedTrl,
                    graphComparativeSavedNc: graphComparativeSavedNc,
                    graphComparativeSavedNr: graphComparativeSavedNr,
                    showGraph: true,
                    numberGraphs: numberGraphs,
                })
            }
            Promise.all([this.getConfig(this.props.dataset), this.getDataset(this.props.dataset),this.getTest(this.props.dataset),this.getSomeGlobalExplanation(this.props.dataset)]).then(() => {
                Promise.all([this.getLocalExplanations(this.props.dataset)]).then(()=> {
                        this.setState({
                            compareTable: true,
                        })
                })
            });
        }
    }
    async returnToAlgorithms(){
        this.setState({
            showGraph:false,
        })
    }

    async getConfig(name) {
        var response = await getConfig(
            name,
            this.props.language.id,
            this.props.token
        );

        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    redirect: true
                });
            } else {
                this.setState({
                    error: true,
                    message: response.data
                });
            }
        } else {
            var maximo=0;
            for(var i=0;i<response.data.attributes.length;i++){
                if(response.data.attributes[i].name.length>maximo){
                    maximo=response.data.attributes[i].name.length;
                }
            }
            console.log(response)
            this.setState(
                {
                    maximo: maximo,
                    config: response.data,
                    isDefault:
                        response.data.dataset === "beer" ||
                        response.data.dataset === "glass" ||
                        response.data.dataset === "wine" ||
                        response.data.dataset === "iris" ||
                        response.data.dataset === "flavia" ||
                        response.data.dataset === "vehicle" ||
                        response.data.dataset === "ACB" ||
                        response.data.dataset === "PIMA" ||
                        response.data.dataset === "OULAD" ||
                        response.data.dataset === "bank" ,
                }
            );
        }
    }
    async getSomeGlobalExplanation(name){
        var response = await getSomeExplanations(
            name,
            this.props.language.id,
            this.props.token
        );
        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    loading: false,
                    redirect: true
                });
            } else {
                this.setState({
                    loading: false,
                    error: true,
                    message: response.data
                });
            }
        } else {
            this.setState({
                globalExplanationJ48: response.data.j48.clauses,
                percentageJ48:response.data.j48.precision.toFixed(2),
                globalExplanationREPTree: response.data.repTree.clauses,
                percentageREPTree:response.data.repTree.precision.toFixed(2),
                globalExplanationRandomTree: response.data.randomTree.clauses,
                percentageRandomTree:response.data.randomTree.precision.toFixed(2),
                globalExplanationFURIA: response.data.furia.clauses,
                percentageFURIA:response.data.furia.precision.toFixed(2),
                globalExplanationHoeffdingTreeFuzzy: response.data.htFuzzy.clauses,
                percentageHoeffdingTreeFuzzy:response.data.htFuzzy.precision.toFixed(2),
                globalExplanationRandomForest: response.data.randomForest.clauses,
                percentageRandomForest:response.data.randomForest.precision.toFixed(2),
            })
        }
    }
    async getDataset(name) {
        var response = await getDataset(name, this.props.token);

        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    redirect: true
                });
            }
            this.setState({
                error: true,
                message: response.data
            });
        } else {
            const labelsInstances = response.data.lines.map((instance, index) => ({
                value: index,
                label: "Instance " + (index + 1)
            }));

            this.setState({
                instances: response.data.lines,
                labelsInstances,
                selectedInstance: labelsInstances[0],
                instanceIndex: 0,
                instance: {
                    attributes: response.data.lines[0].attributes,
                    solution: response.data.lines[0].solution
                }
            });
        }
    }


    handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        this.setState({
            error: false
        });
    };

    changeFile(event) {
        this.setState({
            file: event.target.files[0]
        });
    }


    cancelBuild() {
        if (this.props.classifierExists) {
            console.log('Cancel function' + this.props.lastAlgorithm)
            this.props.changeAlgorithm(this.props.lastAlgorithm, this.state.name).then(
                this.props.handleDataset(this.state.name)
            )
        } else {
            this.setState({
                redirectToHome: true,
            })
        }
    }
    async getValues(){
        var values = { values: {} };
        console.log(Object.keys(this.state.instance.attributes).length)
        for (var i = 0; i < Object.keys(this.state.instance.attributes).length; i++) {
            values.values[this.state.instance.attributes[i + 1].id] =
                this.state.instance.attributes[i + 1].value;
            if(i===(Object.keys(this.state.instance.attributes).length)-1){
                values["solution"] = this.state.instance.solution;
                return values;
            }
        }
    }
    async getLocalExplanations(name) {
        var values = await this.getValues();
        console.log("Hola los values")
        console.log(values)
            var response = await getSomeClassifications(
                name,
                this.props.language.id,
                0,
                values,
                this.props.token
            );

            if (response.error) {
                if (response.status === 401) {
                    this.props.handleGlobalMessage(
                        "error",
                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                    );
                    this.props.closeSession();
                    this.setState({
                        redirect: true
                    });
                } else {
                    this.setState({
                        error: true,
                        message: response.data
                    });
                }
            } else {
                console.log(response.data)
                this.setState({
                        classificationsJ48: response.data.classificationsJ48,
                        classificationsREPTree: response.data.classificationsREPTree,
                        classificationsRandomTree: response.data.classificationsRandomTree,
                        classificationsFURIA: response.data.classificationsFURIA,
                        classificationsHoeffdingTreeFuzzy: response.data.classificationsHoeffdingTreeFuzzy,
                        rulesHoeffdingTreeFuzzy:response.data.rulesHoeffdingTreeFuzzy,
                        localExplanationRandomForest: response.data.classificationsRadomForest,
                    },
                    async () => {
                        response = await getSomeLocalExplanation(
                            name,
                            this.state.classificationsJ48,
                            this.state.classificationsREPTree,
                            this.state.classificationsRandomTree,
                            this.state.classificationsFURIA,
                            this.state.rulesHoeffdingTreeFuzzy,
                            this.props.language.id,
                            this.props.token
                        );
                        if (response.error) {
                            if (response.status === 401) {
                                this.props.handleGlobalMessage(
                                    "error",
                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                );
                                this.props.closeSession();
                                this.setState({
                                    redirect: true
                                });
                            } else {
                                this.setState({
                                    error: true,
                                    message: response.data
                                });
                            }
                        } else {
                            this.setState({
                                localExplanationJ48: response.data.j48.clauses,
                                localExplanationREPTree: response.data.repTree.clauses,
                                localExplanationRandomTree: response.data.randomTree.clauses,
                                localExplanationFURIA: response.data.furia.clauses,
                                localExplanationHoeffdingTreeFuzzy: response.data.htFuzzy.clauses,
                            });
                        }
                    })
            }
    }

    async changeAlgorithm() {
        console.log(this.state.j48)
        console.log(this.state.randomTree)
        console.log(this.state.repTree)
        console.log(this.state.furia)
        if(this.state.j48){

            return this.props.changeAlgorithmDataset("J48",this.state.name);

            }else{
                if(this.state.randomTree){
                    return this.props.changeAlgorithmDataset("RandomTree",this.state.name);
                }else{
                    if(this.state.repTree){
                        return this.props.changeAlgorithmDataset("REPTree",this.state.name);
                    }else{
                        if(this.state.furia){
                            return this.props.changeAlgorithmDataset("FURIA",this.state.name);
                        }else{
                            if(this.state.htFuzzy){
                                return this.props.changeAlgorithmDataset("FuzzyHoeffdingDecisionTree",this.state.name);
                            }else{
                                if(this.state.randomForest){
                                    return this.props.changeAlgorithmDataset("RandomForest",this.state.name);
                                }else{

                                }
                            }
                        }
                    }
                }
        }
        /*if (algorithm === "FURIA") {
            var response = await getRules(
                this.props.dataset,
                algorithm,
                this.props.language.id,
                this.props.token
            );
            if (!response.error) {
                this.setState({
                    redirect: true
                });
            }
        } else {
            response = await getTree(
                this.props.dataset,
                algorithm,
                this.props.language.id,
                this.props.token
            );
            console.log(response.error);
            if (!response.error) {
                this.setState({
                    redirect: true
                });
            }
        }*/
    }

    selectOneAlgorithm(algoritmo){
        console.log('Aqui cehgamos'+algoritmo)
        if(algoritmo === "J48"){
            this.setState({
                j48:true,
                randomTree:false,
                repTree:false,
                furia:false,
                htFuzzy:false,
                randomForest:false,
            })
        }else if(algoritmo === "RandomTree"){
            this.setState({
                j48:false,
                randomTree:true,
                repTree:false,
                furia:false,
                htFuzzy:false,
                randomForest:false,
            })
        }else if(algoritmo === "REPTree"){
            this.setState({
                j48:false,
                randomTree:false,
                repTree:true,
                furia:false,
                htFuzzy:false,
                randomForest:false,
            })
        }else if(algoritmo === "FURIA"){
            this.setState({
                j48:false,
                randomTree:false,
                repTree:false,
                furia:true,
                htFuzzy:false,
                randomForest:false,
            })
        }else if(algoritmo === "FuzzyHoeffdingDecisionTree"){
            this.setState({
                j48:false,
                randomTree:false,
                repTree:false,
                furia:false,
                htFuzzy:true,
                randomForest:false,
            })
        }else if(algoritmo === "RandomForest"){
            this.setState({
                j48:false,
                randomTree:false,
                repTree:false,
                furia:false,
                htFuzzy:false,
                randomForest:true,
            })
        }
    }
    handleChangeSwitchA= event => {
        if(this.state.checkedA === false && this.state.checkedB === true){
            this.setState({
                checkedA: true,
                checkedB: false,
                j48:true,
                repTree:true,
                randomTree:true,
                furia:true,
                htFuzzy:true,
                randomForest:true,
            })
        }else if(this.state.checkedA === false){
            this.setState({
                checkedA: true,
                j48:true,
                repTree:true,
                randomTree:true,
                furia:true,
                htFuzzy:true,
                randomForest:true,
            })
        }else{
            this.setState({
                checkedB: false,
            })
        }
    }
    handleChangeSwitchB= event => {
        if(this.state.checkedB === false && this.state.checkedA === true){
            this.setState({
                checkedB: true,
                checkedA: false,
                j48:false,
                repTree:false,
                randomTree:false,
                furia:false,
                htFuzzy:false,
                randomForest:false,
            })
        }else if(this.state.checkedB === false){
            this.setState({
                checkedB: true,
                j48:false,
                repTree:false,
                randomTree:false,
                furia:false,
                htFuzzy:false,
                randomForest:false,
            })
        }else{
            this.setState({
                checkedB: false,
            })
        }
    }
    handleChangeSwitchSeparated= event => {
        var boolSep=this.state.checkedSeparated;
        this.setState({
            checkedSeparated: !boolSep,
        })

    }
    handleChangeRules(){
        this.setState({
            checkedRules:!this.state.checkedRules,
        })
    }
    handleChangeConcepts(){
        this.setState({
            checkedConcepts:!this.state.checkedConcepts,
        })
    }
    handleChangeTRL(){
        this.setState({
            checkedTRL:!this.state.checkedTRL,
        })
    }
    handleChangeGlobal(){
        this.setState({
            checkedGlobal:!this.state.checkedGlobal,
        })
    }
    handleChangeLocal(){
        this.setState({
            checkedLocal:!this.state.checkedLocal,
        })
    }
    handleAlgorithmClick(algoritmo,checked){
        console.log(algoritmo+" "+checked);
        if(algoritmo === "J48" ){
            if(checked && this.state.randomTree && this.state.repTree
                && this.state.furia && this.state.htFuzzy && this.state.randomForest){
                this.setState({checkedA:true,j48:checked});
            }else{
                this.setState({checkedA:false,j48:checked});
            }
            if(!checked && !this.state.randomTree && !this.state.repTree
                && !this.state.furia && !this.state.htFuzzy && !this.state.randomForest){
                this.setState({checkedB:true,j48:checked});
            }else{
                this.setState({checkedB:false,j48:checked});
            }
        }else if(algoritmo === "RandomTree"){
            if(this.state.j48 && checked && this.state.repTree
                && this.state.furia && this.state.htFuzzy && this.state.randomForest){
                this.setState({checkedA:true,randomTree:checked});
            }else{
                this.setState({checkedA:false,randomTree:checked});
            }
            if(!checked && !this.state.j48 && !this.state.repTree
                && !this.state.furia && !this.state.htFuzzy && !this.state.randomForest){
                this.setState({checkedB:true,randomTree:checked});
            }else{
                this.setState({checkedB:false,randomTree:checked});
            }
        }else if(algoritmo === "REPTree"){
            if(this.state.j48 && checked && this.state.randomTree
                && this.state.furia && this.state.htFuzzy && this.state.randomForest){
                this.setState({checkedA:true,repTree:checked});
            }else{
                this.setState({checkedA:false,repTree:checked});
            }
            if(!checked && !this.state.j48 && !this.state.randomTree
                && !this.state.furia && !this.state.htFuzzy && !this.state.randomForest){
                this.setState({checkedB:true,repTree:checked});
            }else{
                this.setState({checkedB:false,repTree:checked});
            }
        }else if(algoritmo === "FURIA"){
            if(this.state.j48 && checked && this.state.randomTree
                && this.state.repTree && this.state.htFuzzy && this.state.randomForest){
                this.setState({checkedA:true,furia:checked});
            }else{
                this.setState({checkedA:false,furia:checked});
            }
            if(!checked && !this.state.j48 && !this.state.randomTree
                && !this.state.repTree && !this.state.htFuzzy && !this.state.randomForest){
                this.setState({checkedB:true,furia:checked});
            }else{
                this.setState({checkedB:false,furia:checked});
            }
        }else if(algoritmo === "FuzzyHoeffdingDecisionTree"){
            if(this.state.j48 && checked && this.state.randomTree
                && this.state.furia && this.state.furia && this.state.randomForest){
                this.setState({checkedA:true,htFuzzy:checked});
            }else{
                this.setState({checkedA:false,htFuzzy:checked});
            }
            if(!checked && !this.state.j48 && !this.state.randomTree
                && !this.state.furia && !this.state.furia && !this.state.randomForest){
                this.setState({checkedB:true,htFuzzy:checked});
            }else{
                this.setState({checkedB:false,htFuzzy:checked});
            }
        }else if(algoritmo === "RandomForest"){
            if(this.state.j48 && checked && this.state.randomTree
                && this.state.furia && this.state.furia && this.state.htFuzzy){
                this.setState({checkedA:true,randomForest:checked});
            }else{
                this.setState({checkedA:false,randomForest:checked});
            }
            if(!checked && !this.state.j48 && !this.state.randomTree
                && !this.state.furia && !this.state.furia && !this.state.htFuzzy){
                this.setState({checkedB:true,randomForest:checked});
            }else{
                this.setState({checkedB:false,randomForest:checked});
            }
        }

    }
    async selectLine(event) {
        console.log (this.state.graphComparative);
        let posicion=null;
        let posicionHidden=null;
        for(var i =0;i<this.state.graphComparative.length;i++){
            if(this.state.graphComparative[i].algorithm===event.value.toString()){
                console.log("Entra no if aqui"+posicion)
                posicion=i
            }
        }
        for( i =0;i<this.state.graphComparativeHidden.length;i++){
            if(this.state.graphComparativeHidden[i].algorithm===event.value.toString()){
                console.log("Entra no if aqui"+posicion)
                posicionHidden=i
            }
        }
        if(posicion !== null) {
            var removed = this.state.graphComparative.splice(posicion, 1);
            removed[0].percentage = null;
            var grapharray = this.state.graphComparativeHidden.concat(removed);
            console.log(this.state.graphComparativeHidden)
            console.log(this.state.graphComparative)
            console.log(this.state.graphComparativeSaved)
            this.setState({
                graphComparativeHidden:grapharray,
            })
        }
        if(posicionHidden !== null){

            var percentageSaved =null;
            console.log(this.state.graphComparativeSaved)
            for( i=0;i<this.state.graphComparativeSaved.length; i++){
                if(this.state.graphComparativeSaved[i].algorithm===this.state.graphComparativeHidden[posicionHidden].algorithm){
                    percentageSaved=this.state.graphComparativeSaved[i].percentage;
                    console.log(percentageSaved)
                }
            }
            var added = this.state.graphComparativeHidden.splice(posicionHidden, 1)
            added[0].percentage=percentageSaved;
             grapharray = this.state.graphComparative.concat(added);
            this.setState({
                graphComparative:grapharray,
            })
        }
    }
    async selectLineAll(event) {
        console.log (this.state.graphComparative);
        let posicion=null;
        let posicionHidden=null;
        console.log(event.value)
        var split = event.value.split("-");
        console.log(split)
        if(split[1]==="NR") {
            for (var i = 0; i < this.state.graphComparativeTogetherNr.length; i++) {
                if (this.state.graphComparativeTogetherNr[i].algorithm === event.value) {
                    console.log("Entra no if aqui" + posicion)
                    posicion = i
                }
            }
            for ( i = 0; i < this.state.graphComparativeHiddenNr.length; i++) {
                if (this.state.graphComparativeHiddenNr[i].algorithm === event.value) {
                    console.log("Entra no if aqui" + posicion)
                    posicionHidden = i
                }
            }
            if (posicion !== null) {
                var removed = this.state.graphComparativeTogetherNr.splice(posicion, 1);
                removed[0].percentage = null;
                var grapharray = this.state.graphComparativeHiddenNr.concat(removed);
                console.log(this.state.graphComparativeHiddenNr)
                console.log(this.state.graphComparativeTogetherNr)
                console.log(this.state.graphComparativeSavedNr)
                this.setState({
                    graphComparativeHiddenNr: grapharray,
                })
            }
            if (posicionHidden !== null) {

                var percentageSaved = null;
                console.log(this.state.graphComparativeSavedNr)
                for ( i = 0; i < this.state.graphComparativeSavedNr.length; i++) {
                    if (this.state.graphComparativeSavedNr[i].algorithm === this.state.graphComparativeHiddenNr[posicionHidden].algorithm) {
                        percentageSaved = this.state.graphComparativeSavedNr[i].percentage;
                        console.log(percentageSaved)
                    }
                }
                var added = this.state.graphComparativeHiddenNr.splice(posicionHidden, 1)
                added[0].percentage = percentageSaved;
                 grapharray = this.state.graphComparativeTogetherNr.concat(added);
                this.setState({
                    graphComparativeTogetherNr: grapharray,
                })
            }
        }else if(split[1]==="NC"){
                for ( i = 0; i < this.state.graphComparativeTogetherNc.length; i++) {
                    if (this.state.graphComparativeTogetherNc[i].algorithm === event.value) {
                        console.log("Entra no if aqui" + posicion)
                        posicion = i
                    }
                }
                for ( i = 0; i < this.state.graphComparativeHiddenNc.length; i++) {
                    if (this.state.graphComparativeHiddenNc[i].algorithm === event.value) {
                        console.log("Entra no if aqui" + posicion)
                        posicionHidden = i
                    }
                }
                if (posicion !== null) {
                     removed = this.state.graphComparativeTogetherNc.splice(posicion, 1);
                    removed[0].percentage = null;
                    grapharray = this.state.graphComparativeHiddenNc.concat(removed);
                    console.log(this.state.graphComparativeHiddenNc)
                    console.log(this.state.graphComparativeTogetherNc)
                    console.log(this.state.graphComparativeSavedNc)
                    this.setState({
                        graphComparativeHiddenNc: grapharray,
                    })
                }
                if (posicionHidden !== null) {
                    percentageSaved = null;
                    console.log(this.state.graphComparativeSavedNc)
                    for ( i = 0; i < this.state.graphComparativeSavedNc.length; i++) {
                        if (this.state.graphComparativeSavedNc[i].algorithm === this.state.graphComparativeHiddenNc[posicionHidden].algorithm) {
                            percentageSaved = this.state.graphComparativeSavedNc[i].percentage;
                            console.log(percentageSaved)
                        }
                    }
                     added = this.state.graphComparativeHiddenNc.splice(posicionHidden, 1)
                    added[0].percentage = percentageSaved;
                    grapharray = this.state.graphComparativeTogetherNc.concat(added);
                    this.setState({
                        graphComparativeTogetherNc: grapharray,
                    })
                }
        }else if(split[1]==="TRL"){
                for ( i = 0; i < this.state.graphComparativeTogetherTrl.length; i++) {
                    if (this.state.graphComparativeTogetherTrl[i].algorithm === event.value) {
                        console.log("Entra no if aqui" + posicion)
                        posicion = i
                    }
                }
                for ( i = 0; i < this.state.graphComparativeHiddenTrl.length; i++) {
                    if (this.state.graphComparativeHiddenTrl[i].algorithm === event.value) {
                        console.log("Entra no if aqui" + posicion)
                        posicionHidden = i
                    }
                }
                if (posicion !== null) {
                     removed = this.state.graphComparativeTogetherTrl.splice(posicion, 1);
                    removed[0].percentage = null;
                     grapharray = this.state.graphComparativeHiddenTrl.concat(removed);
                    console.log(this.state.graphComparativeHiddenTrl)
                    console.log(this.state.graphComparativeTogetherTrl)
                    console.log(this.state.graphComparativeSavedTrl)
                    this.setState({
                        graphComparativeHiddenTrl: grapharray,
                    })
                }
                if (posicionHidden !== null) {
                    percentageSaved = null;
                    console.log(this.state.graphComparativeSavedTrl)
                    for ( i = 0; i < this.state.graphComparativeSavedTrl.length; i++) {
                        if (this.state.graphComparativeSavedTrl[i].algorithm === this.state.graphComparativeHiddenTrl[posicionHidden].algorithm) {
                            percentageSaved = this.state.graphComparativeSavedTrl[i].percentage;
                            console.log(percentageSaved)
                        }
                    }
                    added = this.state.graphComparativeHiddenTrl.splice(posicionHidden, 1)
                    added[0].percentage = percentageSaved;
                    grapharray = this.state.graphComparativeTogetherTrl.concat(added);
                    this.setState({
                        graphComparativeTogetherTrl: grapharray,
                    })
                }

        }
    }
    handleChangeName = event => {
        var regex = /^[A-Za-z0-9]{4,20}$/;
        console.log(event.target)
        this.setState({
            nameError: event.target.value.match(regex) ? false : true,
            name: event.target.value
        });
    };

    a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
    }
    handleChange = (event, newValue) => {
        this.setState({
            value:newValue
        });
    };
    handleChangeTrain = event => {
        if (event !== null) {
            this.setState({
                selected: "train",
                instanceIndex: event.value.toString(),
                selectedInstance: event,
                instance: {
                    attributes: this.state.instances[event.value].attributes,
                    solution: this.state.instances[event.value].solution
                },
                userInstance: null,
            });
        }
    };

    handleChangeTest = event => {
        if (event !== null) {
            this.setState({
                selected: "test",
                instanceTestIndex: event.value.toString(),
                selectedTestInstance: event,
                instance: {
                    attributes: this.state.instancesTest[event.value].attributes,
                    solution: this.state.instancesTest[event.value].solution
                },
                userInstance: null
            });
        }
    };
    async changeLock()  {
        if(this.state.typeInstanceSelected === 0) {
            this.setState({
                typeInstanceSelected:1,
                instance: {
                    attributes: this.state.instances[this.state.instanceIndex].attributes,
                    solution: this.state.instances[this.state.instanceIndex].solution
                },
            })
        }else{
            if(!this.state.instancesTest===undefined && !this.state.instancesTest === null) {
                this.setState({
                    typeInstanceSelected: 0,
                    instance: {
                        attributes: this.state.instancesTest[this.state.instanceTestIndex].attributes,
                        solution: this.state.instancesTest[this.state.instanceTestIndex].solution
                    },
                })
            }else{
                this.setState({
                    typeInstanceSelected: 0,
                })
            }
        }
    }
    async getTest(name) {
        var response = await getTest(name, this.props.token);

        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    redirect: true
                });
            } else {
                this.setState({
                    selected: "train"
                });
            }
        } else {
            const labelsTestInstances = response.data.lines.map(
                (instance, index) => ({
                    value: index,
                    label: "Instance " + (index + 1)
                })
            );

            this.setState({
                instancesTest: response.data.lines,
                labelsTestInstances,
                selectedTestInstance: labelsTestInstances[0],
                instanceTestIndex: 0,
                instance: {
                    attributes: response.data.lines[0].attributes,
                    solution: response.data.lines[0].solution
                }
            });
        }
    }
    async uploadTest(event) {
        var response = await uploadTest(
            this.state.config.dataset,
            event.target.files[0],
            this.props.token
        );

        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    redirect: true
                });
            } else {
                this.setState({
                    error: true,
                    message: response.data
                });
            }
        } else {
            response = await getTest(this.props.dataset, this.props.token);
            if (response.error) {
                if (response.status === 401) {
                    this.props.handleGlobalMessage(
                        "error",
                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                    );
                    this.props.closeSession();
                    this.setState({
                        redirect: true
                    });
                } else {
                    this.setState({
                        error: true,
                        message: response.data
                    });
                }
            } else {
                const labelsTestInstances = response.data.lines.map(
                    (instance, index) => ({
                        value: index,
                        label: "Instance " + (index + 1)
                    }),
                );
                if(this.props.algorithm ==="FURIA" || this.props.algorithm === "FuzzyHoeffdingDecisionTree") {
                    var responseFingrams = await buildFingramsTest(
                        this.state.config.dataset,
                        this.props.algorithm,
                        this.props.token,
                        this.props.language.id
                    );
                    if (responseFingrams.error) {
                        if (responseFingrams.status === 401) {
                            this.props.handleGlobalMessage(
                                "error",
                                this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                            );
                            this.props.closeSession();
                            this.setState({
                                loading: false,
                                redirect: true
                            });
                        } else {
                            this.setState({
                                loading: false,
                                error: true,
                                message: responseFingrams.data
                            });
                        }
                    } else {
                        this.props.handleGlobalMessage(
                            "success",
                            "Dataset " + this.state.name +this.props.language.labels[this.props.language.id].succesfullyCreated
                        );
                        this.setState(
                            {
                                loading: false,
                                ready: true
                            });
                        this.props.getSvgFingramTest();
                        this.props.getLogFingramsTest();
                    }
                }
                this.setState({
                    instancesTest: response.data.lines,
                    instanceTestIndex: 0,
                    labelsTestInstances,
                    selectedTestInstance: labelsTestInstances[0],
                    instance: {
                        attributes: response.data.lines[0].attributes,
                        solution: response.data.lines[0].solution
                    }
                });
            }
        }
    }
    toggleDrawer = (side, open) => () => {
        this.setState({
            [side]: open
        });
    };
    classify(){
        this.getLocalExplanations(this.props.dataset)
    }
    render() {
        const { classes } = this.props;
        console.log(this.state.instance)
        console.log(this.state.config)

        var tableView = (
            <div style={{padding:20}}>
            <Paper style={{margin:"auto",textAlign:"center",minWidth:650,width:"80%"}} >
            <Table  className={classes.table}
               aria-label="simple table">
            <TableHead className={classes.head}>
                <TableCell>Name</TableCell>
                <TableCell>Value</TableCell>
                <TableCell>Property name</TableCell>
                <TableCell>Property value</TableCell>
            </TableHead>
            {this.state.config !== undefined && this.state.instance!==undefined &&
            <TableBody>

                {this.state.config.attributes.map((att, index) => {
                    return <><TableRow>
                        <TableCell  style={{border:"solid #e0e0e0"}}
                            rowSpan={this.state.config.attributes[index].properties.length}>{this.state.instance.attributes[index + 1].name}</TableCell>
                        <TableCell style={{border:"solid #e0e0e0"}}
                            rowSpan={this.state.config.attributes[index].properties.length}>{this.state.instance.attributes[index + 1].value}</TableCell>
                        <TableCell style={{border:"solid #e0e0e0"}} >{this.state.config.attributes[index].properties[0].name}</TableCell>
                        <TableCell style={{border:"solid #e0e0e0"}} >{this.state.config.attributes[index].properties[0].interval.right}{" , "}
                            {this.state.config.attributes[index].properties[0].interval.left}</TableCell>
                    </TableRow>
                        {this.state.config.attributes[index].properties.map((prop, indexProp) => {
                            if (indexProp > 0) {
                                return <TableRow>
                                    <TableCell style={{border:"solid #e0e0e0"}}>{this.state.config.attributes[index].properties[indexProp].name}</TableCell>
                                    <TableCell style={{border:"solid #e0e0e0"}}>
                                        {this.state.config.attributes[index].properties[indexProp].interval.right}{" , "}
                                        {this.state.config.attributes[index].properties[indexProp].interval.left}
                                    </TableCell>
                                </TableRow>
                            }
                        })}
                    </>
                })}

            </TableBody>
            }
        </Table>
            </Paper>
            </div>
        )
        return this.state.loading ? (
            <Fragment>
            <NavBar
                language={this.props.language}
                handleLanguageChange={this.props.handleLanguageChange}
                comparationMode={true}
                goToDisplay={this.props.goToDisplay}
            />
            <div className={classes.loader}>
                <CircularProgress className={classes.progress} size={100} />
                <Typography variant="h3" align="center">
                    {this.props.language.labels[this.props.language.id].loading}
                </Typography>
            </div>
            </Fragment>
        ) : (
            <Fragment>
                <NavBar
                    language={this.props.language}
                    handleLanguageChange={this.props.handleLanguageChange}
                    comparationMode={true}
                    goToDisplay={this.props.goToDisplay}
                />
                {this.state.showGraph === false &&
                <Grid container style={{marginBottom:110,marginTop: 80}} justify="center">
                    <Grid xs={12} className={classes.container}>
                        <Fragment>
                            <Typography variant="h4">
                                {this.props.language.labels[this.props.language.id].graphComparativeTitle}
                            </Typography>
                            <FormGroup row>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            disabled={this.state.checkedA}
                                            disableRipple={true}
                                            classes={{disabled: classes.switchClassDisabled}}
                                            checked={this.state.checkedA}
                                            color="primary"
                                            onChange={this.handleChangeSwitchA}
                                            name="checkedA"
                                            inputProps={{'aria-label': 'primary checkbox'}}
                                        />}
                                    label={this.props.language.labels[this.props.language.id].selectAll}
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            disabled={this.state.checkedB}
                                            checked={this.state.checkedB}
                                            onChange={this.handleChangeSwitchB}
                                            color="primary"
                                            name="checkedB"
                                            inputProps={{'aria-label': 'primary checkbox'}}
                                        />
                                    }
                                    label={this.props.language.labels[this.props.language.id].deselectAll}
                                />
                            </FormGroup>
                            <FormLabel style={{marginTop:20}} component="legend">{this.props.language.labels[this.props.language.id].typeGraph}</FormLabel>
                            <FormGroup row>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.checkedRules}
                                            onChange={this.handleChangeRules}
                                            name="checkedB"
                                            color="primary"
                                        />
                                    }
                                    label={this.props.language.labels[this.props.language.id].numberRules}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.checkedConcepts}
                                            onChange={this.handleChangeConcepts}
                                            name="checkedGlobal"
                                            color="primary"
                                        />
                                    }
                                    label={this.props.language.labels[this.props.language.id].numberConcepts}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.checkedTRL}
                                            onChange={this.handleChangeTRL}
                                            name="checkedGlobal"
                                            color="primary"
                                        />
                                    }
                                    label={this.props.language.labels[this.props.language.id].trl}
                                />
                            </FormGroup>
                            <FormLabel  style={{marginTop:20}} component="legend">{this.props.language.labels[this.props.language.id].typeExplanation}</FormLabel>
                            <FormGroup row>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.checkedLocal}
                                            onChange={this.handleChangeLocal}
                                            name="checkedB"
                                            color="primary"
                                        />
                                    }
                                    label={this.props.language.labels[this.props.language.id].localExplanation}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.checkedGlobal}
                                            onChange={this.handleChangeGlobal}
                                            name="checkedGlobal"
                                            color="primary"
                                        />
                                    }
                                    label={this.props.language.labels[this.props.language.id].globalExplanation}
                                />
                            </FormGroup>
                        </Fragment>
                    </Grid>
                    <Grid item xs={12} className={classes.root}>
                        {this.state.listOfAlgorithms &&
                        <Fragment>
                            {this.state.listOfAlgorithms.map(algorithm => {
                                var checked = false;
                                if (algorithm === "J48" && this.state.j48) {
                                    checked = true;
                                } else if (algorithm === "RandomTree" && this.state.randomTree) {
                                    checked = true;
                                } else if (algorithm === "REPTree" && this.state.repTree) {
                                    checked = true;
                                } else if (algorithm === "FURIA" && this.state.furia) {
                                    checked = true;
                                } else if (algorithm === "FuzzyHoeffdingDecisionTree" && this.state.htFuzzy) {
                                    checked = true;
                                } else if (algorithm === "RandomForest" && this.state.randomForest) {
                                    checked = true;
                                }
                                console.log('checked' + algorithm + " " + checked)
                                return (
                                    <AlgorithmCard
                                        key={algorithm}
                                        language={this.props.language}
                                        handleAlgorithmClick={this.handleAlgorithmClick}
                                        algorithm={algorithm}
                                        algorithmChecked={this.props.algorithmChecked}
                                        selectOneAlgorithm={this.selectOneAlgorithm}
                                        checked={checked}
                                        showConfig={false}
                                    />
                                );
                            })}

                        </Fragment>
                        }
                    </Grid>
                    <Button
                        variant="contained"
                        className={classes.button}
                        onClick={this.buildClassifier}
                    >
                        {this.props.language.labels[this.props.language.id].compare}
                    </Button>
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    <Button
                        variant="contained"
                        className={classes.buttonCancel}
                        onClick={this.cancelBuild}
                    >
                        {this.props.language.labels[this.props.language.id].cancelButton}
                    </Button>
                </Grid>
                }
                {this.state.showGraph === true &&
                <Grid container className={classes.root}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Paper className={classes.paperRight}>
                            {(this.state.j48 || this.state.randomTree || this.state.repTree || this.state.furia || this.state.htFuzzy) &&
                            (this.state.checkedRules || this.state.checkedConcepts || this.state.checkedTRL) &&
                            (this.state.checkedLocal || this.state.checkedGlobal) &&
                            <Tabs className={classes.containerResponsive} value={this.state.value}
                                  onChange={this.handleChange} aria-label="simple tabs example">
                                <Tab style={{marginLeft: "auto"}} label="Graph" {...this.a11yProps(0)} />
                                <Tab style={{marginRight: "auto"}} label="Explanation" {...this.a11yProps(1)} />
                            </Tabs>
                            }
                            {this.state.value === 0 && (this.state.j48 || this.state.randomTree || this.state.repTree || this.state.furia || this.state.furia || this.state.htFuzzy) && (this.state.checkedRules || this.state.checkedConcepts || this.state.checkedTRL) &&
                            <div className={classes.containerResponsive}
                                 style={{marginBottom: 100, marginTop: 80, width: "100%"}}>
                                <Typography variant="h4">
                                    {this.props.language.labels[this.props.language.id].graphComparativeTitle2}
                                </Typography>
                                <>{this.state.numberGraphs > 1 &&
                                <FormControlLabel
                                    control={
                                        <Switch
                                            disabled={false}
                                            disableRipple={false}
                                            classes={{disabled: classes.switchClassDisabled}}
                                            checked={this.state.checkedSeparated}
                                            color="primary"
                                            onChange={this.handleChangeSwitchSeparated}
                                            name="checkedSeparated"
                                            inputProps={{'aria-label': 'primary checkbox'}}
                                        />}
                                    label="Separated Graphs"
                                />
                                }</>
                                <div style={{width: "100%"}}>
                                    {this.state.checkedRules && this.state.checkedSeparated &&
                                    <div style={{width: "50%", margin: "auto"}}>
                                        <Typography variant="h5">
                                            Accuracy (CCI) vs Interpretability (Number of rules)
                                        </Typography>
                                        <Typography variant="h6">
                                            Percenatge of CCI= Correctly Classified Instances
                                        </Typography>
                                        <ResponsiveContainer width={"100%"} height={300}>
                                            < ScatterChart
                                                margin={{top: 20, right: 50, left: 50, bottom: 50}}
                                            >
                                                <CartesianGrid/>
                                                <XAxis type="number" dataKey="numberOfRules" name="NR"/>
                                                <YAxis type="number" dataKey="percentage" name="CCI"/>
                                                <Tooltip content={"algorithm"}/>
                                                {this.state.graphComparative.map(x => {
                                                    return (<Scatter name={x.algorithm} data={[x]} line fill="#4caf50">
                                                        <LabelList dataKey="algorithm" position="top"/>
                                                    </Scatter>)
                                                })
                                                }
                                                {this.state.graphComparativeHidden.map(x => {
                                                    return (<Scatter name={x.algorithm} data={[x]} line fill="red">
                                                        <LabelList dataKey="algorithm" position="top"/>
                                                    </Scatter>)
                                                })
                                                }
                                                <Legend onClick={this.selectLine}/>
                                            </ScatterChart>
                                        </ResponsiveContainer>
                                    </div>
                                    }
                                    {this.state.checkedConcepts && this.state.checkedSeparated &&
                                    <div style={{width: "50%", margin: "auto"}}>
                                        <Typography variant="h5">
                                            Accuracy (CCI) vs Interpretability (Number of Concepts)
                                        </Typography>
                                        <Typography variant="h6">
                                            Percentage of CCI= Correctly Classified Instances
                                        </Typography>
                                        <ResponsiveContainer width={"100%"} height={300}>

                                            <ScatterChart
                                                margin={{top: 20, right: 50, left: 50, bottom: 50}}
                                            >
                                                <CartesianGrid/>

                                                <XAxis type="number" dataKey="numberOfConcepts" name="NC"/>
                                                <YAxis type="number" dataKey="percentage" name="CCI"/>
                                                <Tooltip cursor={{strokeDasharray: '3 3'}}/>
                                                {this.state.graphComparative.map(x => {
                                                    return (<Scatter name={x.algorithm} data={[x]} line fill="#4caf50">
                                                        <LabelList dataKey="algorithm" position="top"/>
                                                    </Scatter>)
                                                })
                                                }
                                                {this.state.graphComparativeHidden.map(x => {
                                                    return (<Scatter name={x.algorithm} data={[x]} line fill="red">
                                                        <LabelList dataKey="algorithm" position="top"/>
                                                    </Scatter>)
                                                })
                                                }
                                                <Legend onClick={this.selectLine}/>
                                            </ScatterChart>
                                        </ResponsiveContainer>
                                    </div>
                                    }
                                    {this.state.checkedTRL && this.state.checkedSeparated &&
                                    <div style={{width: "50%", margin: "auto"}}>
                                        <Typography variant="h5">
                                            Accuracy (CCI) vs Interpretability (TRL)
                                        </Typography>
                                        <Typography variant="h6">
                                            Percentage of CCI= Correctly Classified Instances
                                        </Typography>
                                        <ResponsiveContainer width={"100%"} height={300}>

                                            <ScatterChart
                                                margin={{top: 20, right: 50, left: 50, bottom: 50}}

                                            >
                                                <CartesianGrid/>
                                                <XAxis type="number" dataKey="trl" name="TRL"/>
                                                <YAxis type="number" dataKey="percentage" name="CCI"/>
                                                <Tooltip cursor={{strokeDasharray: '3 3'}}/>
                                                {this.state.graphComparative.map(x => {
                                                    return (<Scatter name={x.algorithm} data={[x]} line fill="#4caf50">
                                                        <LabelList dataKey="algorithm" position="top"/>
                                                    </Scatter>)
                                                })
                                                }
                                                {this.state.graphComparativeHidden.map(x => {
                                                    return (<Scatter name={x.algorithm} data={[x]} line fill="red">
                                                        <LabelList dataKey="algorithm" position="top"/>
                                                    </Scatter>)
                                                })
                                                }
                                                <Legend onClick={this.selectLine}/>
                                            </ScatterChart>
                                        </ResponsiveContainer>
                                    </div>
                                    }
                                    {!this.state.checkedSeparated &&
                                    <div style={{width: "80%", margin: "auto"}}>
                                        <Typography variant="h5">
                                            Accuracy (CCI) vs Interpretability
                                            {this.state.checkedTRL && "(TRL)"}
                                            {this.state.checkedRules && "(Number of Rules)"}
                                            {this.state.checkedConcepts && "(Number of concepts)"}
                                        </Typography>
                                        <Typography variant="h6">
                                            Percentage of CCI= Correctly Classified Instances
                                        </Typography>
                                        <ResponsiveContainer width={"100%"} height={600}>
                                            <ScatterChart
                                                margin={{top: 20, right: 50, left: 50, bottom: 50}}
                                            >
                                                <CartesianGrid/>
                                                <XAxis type="number" dataKey="numberOfRules" name="Interpretability"/>
                                                <YAxis type="number" dataKey="percentage" name="CCI"/>
                                                <Tooltip cursor={{strokeDasharray: '3 3'}}/>
                                                {this.state.checkedRules && this.state.graphComparativeTogetherNr.map(x => {
                                                    return (<Scatter name={x.algorithm} data={[x]} line fill="#4caf50">
                                                        <LabelList dataKey="algorithm" position="top"/>
                                                    </Scatter>)
                                                })
                                                }
                                                {this.state.checkedConcepts && this.state.graphComparativeTogetherNc.map(x => {
                                                    return (<Scatter name={x.algorithm} data={[x]} line fill="#2186f2">
                                                        <LabelList dataKey="algorithm" position="top"/>
                                                    </Scatter>)
                                                })
                                                }
                                                {this.state.checkedTRL && this.state.graphComparativeTogetherTrl.map(x => {
                                                    return (<Scatter name={x.algorithm} data={[x]} line fill="#df21f2">
                                                        <LabelList dataKey="algorithm" position="top"/>
                                                    </Scatter>)
                                                })
                                                }
                                                {this.state.graphComparativeHiddenNr.map(x => {
                                                    return (<Scatter name={x.algorithm} data={[x]} line fill="red">
                                                        <LabelList dataKey="algorithm" position="top"/>
                                                    </Scatter>)
                                                })}
                                                {this.state.graphComparativeHiddenNc.map(x => {
                                                    return (<Scatter name={x.algorithm} data={[x]} line fill="red">
                                                        <LabelList dataKey="algorithm" position="top"/>
                                                    </Scatter>)
                                                })}
                                                {this.state.graphComparativeHiddenTrl.map(x => {
                                                    return (<Scatter name={x.algorithm} data={[x]} line fill="red">
                                                        <LabelList dataKey="algorithm" position="top"/>
                                                    </Scatter>)
                                                })
                                                }
                                                <Legend onClick={this.selectLineAll}/>
                                            </ScatterChart>
                                        </ResponsiveContainer>
                                    </div>
                                    }
                                </div>
                                <Button
                                    variant="contained"
                                    className={classes.buttonCancel}
                                    onClick={this.returnToAlgorithms}
                                >
                                    {this.props.language.labels[this.props.language.id].returnButton}
                                </Button>
                                <ExplanationPanelGraph
                                    checkedRules={this.state.checkedRules}
                                    checkedTRL={this.state.checkedTRL}
                                    checkedConcepts={this.state.checkedConcepts}
                                    language={this.props.language}
                                    arrayNumberRules={this.state.graphComparativeSavedNr}
                                    arrayNumberConcepts={this.state.graphComparativeSavedNc}
                                    arrayTrl={this.state.graphComparativeSavedTrl}
                                />
                            </div>
                            }
                            {(this.state.value ===1 || (!this.state.j48 && !this.state.randomTree && !this.state.repTree && !this.state.furia && !this.state.furia && !this.state.htFuzzy) || (!this.state.checkedRules && !this.state.checkedConcepts && !this.state.checkedTRL) ) && this.state.compareTable && this.state.checkedLocal &&
                                    <>
                                        <div style={{width:"50%",textAlign:"center",margin:"auto"}}>

                                                    {this.state.typeInstanceSelected === 0 &&
                                                        <IconButton onClick={this.changeLock} color="primary" component="span">
                                                            <LockOpenIcon/>
                                                        </IconButton>
                                                    }{ this.state.typeInstanceSelected === 1 &&
                                                        <IconButton onClick={this.changeLock} color="primary" component="span">
                                                            <LockIcon/>
                                                        </IconButton>
                                                        }
                                                    <Typography component={"span"} className={classes.selectLabel} variant="body1">
                                                        {this.props.language.labels[this.props.language.id].test}:
                                                    </Typography>
                                                    {this.state.instancesTest && (
                                                        <Select
                                                            className={classes.select}
                                                            options={this.state.labelsTestInstances}
                                                            value={this.state.selectedTestInstance}
                                                            disabled={this.state.typeInstanceSelected===1}
                                                            onChange={this.handleChangeTest}
                                                        />
                                                    )}
                                                    {!this.state.instancesTest && (
                                                        <>
                                                            <br/>
                                                            <Button disabled={this.state.typeInstanceSelected === 1} component="label" color="primary">
                                                                {this.props.language.labels[this.props.language.id].uploadTest}{" "}
                                                                <CloudUpload />
                                                                <input
                                                                    style={{ display: "none" }}
                                                                    type="file"
                                                                    onChange={this.uploadTest}
                                                                />
                                                            </Button>
                                                            <br/>
                                                        </>
                                                    )}
                                                    {this.state.typeInstanceSelected === 1 &&
                                                    <IconButton onClick={this.changeLock} color="primary" component="span">
                                                        <LockOpenIcon/>
                                                    </IconButton>
                                                    }{ this.state.typeInstanceSelected === 0 &&
                                                <IconButton onClick={this.changeLock} color="primary" component="span">
                                                    <LockIcon/>
                                                </IconButton>
                                                }
                                                    <Typography  component={"span"} className={classes.selectLabel} variant="body1">
                                                        {this.props.language.labels[this.props.language.id].train}:
                                                    </Typography>{" "}
                                                    <Select
                                                        className={classes.select}
                                                        options={this.state.labelsInstances}
                                                        value={this.state.selectedInstance}
                                                        disabled={this.state.typeInstanceSelected===0}
                                                        onChange={this.handleChangeTrain}
                                                    />
                                                    <Button
                                                        style={{color:"white"}}
                                                        variant="contained"
                                                        color="primary"
                                                        className={classes.button}
                                                        onClick={this.classify}
                                                    >
                                                        {this.props.language.labels[this.props.language.id].classify}
                                                    </Button>
                                            &nbsp;&nbsp;&nbsp;
                                                    <Button
                                                        style={{color:"white"}}
                                                        className={classes.button}
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={this.toggleDrawer("left", true)}
                                                    >
                                                        {this.props.language.labels[this.props.language.id].showValues}
                                                    </Button>
                                                    <Drawer
                                                        open={this.state.left}
                                                        onClose={this.toggleDrawer("left", false)}
                                                    >
                                                        <div tabIndex={0} role="button">
                                                            {tableView}
                                                        </div>
                                                    </Drawer>
                                        </div>
                                        <Paper style={{margin:"auto",textAlign:"center",minWidth:650,width:"80%"}}>
                                            <Table className={classes.table} aria-label="simple table">
                                                <TableHead className={classes.head}>
                                                    <TableRow>
                                                        <TableCell style={{color: "white"}}>{this.props.language.labels[this.props.language.id].algorithm}</TableCell>
                                                        <TableCell style={{color: "white"}}>{this.props.language.labels[this.props.language.id].localExplanation}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.j48 && this.state.localExplanationJ48 &&
                                                    <TableRow>
                                                        <TableCell>J48</TableCell>
                                                        <TableCell>
                                                            {this.state.localExplanationJ48.map(item => {
                                                                return item + " ";
                                                            })}
                                                        </TableCell>
                                                    </TableRow>
                                                    }
                                                    {this.state.repTree && this.state.localExplanationREPTree &&
                                                    <TableRow>
                                                        <TableCell>REPTree</TableCell>
                                                        <TableCell>
                                                            {this.state.localExplanationREPTree.map(item => {
                                                                return item + " ";
                                                            })}
                                                        </TableCell>
                                                    </TableRow>
                                                    }
                                                    {this.state.randomTree && this.state.localExplanationRandomTree &&
                                                    <TableRow>
                                                        <TableCell>RandomTree</TableCell>
                                                        <TableCell>
                                                            {this.state.localExplanationRandomTree.map(item => {
                                                                return item + " ";
                                                            })}
                                                        </TableCell>
                                                    </TableRow>
                                                    }
                                                    {this.state.furia && this.state.localExplanationFURIA &&
                                                    <TableRow>
                                                        <TableCell>FURIA</TableCell>
                                                        <TableCell>
                                                            {this.state.localExplanationFURIA.map(item => {
                                                                return item + " ";
                                                            })}
                                                        </TableCell>
                                                    </TableRow>
                                                    }
                                                    {this.state.htFuzzy && this.state.localExplanationHoeffdingTreeFuzzy &&
                                                    <TableRow>
                                                        <TableCell>FuzzyHoeffdingDecisionTree</TableCell>
                                                        <TableCell>
                                                            {this.state.localExplanationHoeffdingTreeFuzzy.map(item => {
                                                                return item + " ";
                                                            })}
                                                        </TableCell>
                                                    </TableRow>
                                                    }
                                                    {this.state.randomForest &&
                                                    <TableRow>
                                                        <TableCell>RandomForest</TableCell>
                                                        <TableCell>
                                                            {this.state.localExplanationRandomForest}
                                                        </TableCell>
                                                    </TableRow>
                                                    }
                                                </TableBody>
                                            </Table>

                                        </Paper>
                                    </>
                                    }
                                    {(this.state.value ===1  || (!this.state.j48 && !this.state.randomTree && !this.state.repTree && !this.state.furia && !this.state.furia && !this.state.htFuzzy) || (!this.state.checkedRules && !this.state.checkedConcepts && !this.state.checkedTRL))  && this.state.compareTable && this.state.checkedGlobal &&
                                    <Fragment>
                                        <Paper style={{margin:"auto",textAlign:"center",minWidth:650,width:"80%",marginTop:100,marginBottom:100}}>

                                            <Table className={classes.table} aria-label="simple table">
                                                <TableHead className={classes.head}>
                                                    <TableRow>
                                                        <TableCell style={{color: "white"}}>{this.props.language.labels[this.props.language.id].algorithm}</TableCell>
                                                        <TableCell style={{color: "white"}}>{this.props.language.labels[this.props.language.id].globalExplanation}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.j48 &&
                                                    <TableRow>
                                                        <TableCell>J48</TableCell>
                                                        <TableCell>
                                                            {this.state.globalExplanationJ48.map(item => {
                                                                return item + " ";
                                                            })}
                                                        </TableCell>
                                                    </TableRow>
                                                    }
                                                    {this.state.repTree &&
                                                    <TableRow>
                                                        <TableCell>REPTree</TableCell>
                                                        <TableCell>
                                                            {this.state.globalExplanationREPTree.map(item => {
                                                                return item + " ";
                                                            })}
                                                        </TableCell>
                                                    </TableRow>
                                                    }
                                                    {this.state.randomTree &&
                                                    <TableRow>
                                                        <TableCell>RandomTree</TableCell>
                                                        <TableCell>
                                                            {this.state.globalExplanationRandomTree.map(item => {
                                                                return item + " ";
                                                            })}
                                                        </TableCell>
                                                    </TableRow>
                                                    }
                                                    {this.state.furia &&
                                                    <TableRow>
                                                        <TableCell>FURIA</TableCell>
                                                        <TableCell>
                                                            {this.state.globalExplanationFURIA.map(item => {
                                                                return item + " ";
                                                            })}
                                                        </TableCell>
                                                    </TableRow>
                                                    }
                                                    {this.state.htFuzzy &&
                                                    <TableRow>
                                                        <TableCell>FuzzyHoeffdingDecisionTree</TableCell>
                                                        <TableCell>
                                                            {this.state.globalExplanationHoeffdingTreeFuzzy.map(item => {
                                                                return item + " ";
                                                            })}
                                                        </TableCell>
                                                    </TableRow>
                                                    }
                                                    {this.state.randomForest && this.state.globalExplanationRandomForest &&
                                                    <TableRow>
                                                        <TableCell>RandomForest</TableCell>
                                                        <TableCell>
                                                            {this.state.globalExplanationRandomForest.map(item => {
                                                                return item + " ";
                                                            })}
                                                        </TableCell>
                                                    </TableRow>
                                                    }
                                                </TableBody>
                                            </Table>

                                        </Paper>
                                        <Button
                                            style={{margin:"auto",marginBottom:50}}
                                            variant="contained"
                                            className={classes.buttonCancel}
                                            onClick={this.returnToAlgorithms}
                                        >
                                            {this.props.language.labels[this.props.language.id].returnButton}
                                        </Button>
                                    </Fragment>
                                    }
                        </Paper>
                    </Grid>
                </Grid>
                }
                <footer className={classes.footer}>
                    <Grid container direction="row" alignItems="center" justify={"center"}>
                        <Grid  className={classes.centerFotter} item xs={12} md={8} lg={8} >
                            <img
                                src={galicia}
                                alt="logo turístico galicia"
                                className={classes.leftLogos}
                            />
                            <img
                                src={xacobeo}
                                alt="logo xacobeo 2021"
                                className={classes.leftLogos}
                            />
                            <img src={citius_horizontal} alt="logo citius" className={classes.leftLogos} />
                            <img src={usc} alt="logo usc" className={classes.leftLogos} />
                            <img
                                src={campusVida}
                                alt="logo campus vida"
                                className={classes.leftLogos}
                            />
                        </Grid>
                        <Grid className={classes.centerFotter}  item xs={12} md={4} lg={4} >
                            <img
                                src={ue}
                                alt="logo unión europea"
                                className={classes.rightLogos}
                            />
                            <img
                                src={xunta}
                                alt="logo xunta de galicia"
                                className={classes.rightLogos}
                            />
                        </Grid>
                    </Grid>
                    <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "center"}}>
                        {this.props.language.labels[this.props.language.id].fondoEuropeo}
                    </Typography>
                </footer>
                <CustomizedSnackbars
                    openFail={this.state.error}
                    handleClose={this.handleClose}
                    message={this.state.message}
                />
                {!this.props.token ? <Redirect to="/" /> : ""}
                {this.state.redirectToHome && <Redirect to="/" /> }
                {this.state.ready && this.props.handleDataset(this.state.name)}
                {this.state.goBackGeneralInformation && <Redirect to={"/classifiersAll"}/>}
            </Fragment>

        );
    }
}
AlgorithmsComparationGraph.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AlgorithmsComparationGraph);
